import React from 'react';
var DefaultItemRenderer = function (_a) {
    var checked = _a.checked, option = _a.option, onClick = _a.onClick, disabled = _a.disabled;
    return (React.createElement("div", { className: "item-renderer ".concat(disabled && 'disabled') },
        React.createElement("input", { type: "checkbox", onChange: onClick, checked: checked, tabIndex: -1, disabled: disabled }),
        React.createElement("span", null, option.label)));
};
export default DefaultItemRenderer;



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/select-panel/DefaultItem.tsx
// module id = 1198
// module chunks = 0